/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Customproperties1Inputs */

const en_nav_customproperties1 = /** @type {(inputs: Nav_Customproperties1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Properties`)
};

const de_nav_customproperties1 = /** @type {(inputs: Nav_Customproperties1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Properties`)
};

/**
* | output |
* | --- |
* | "Custom Properties" |
*
* @param {Nav_Customproperties1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const nav_customproperties1 = /** @type {((inputs?: Nav_Customproperties1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Customproperties1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_customproperties1(inputs)
	return de_nav_customproperties1(inputs)
});
export { nav_customproperties1 as "nav_customProperties" }